export enum DocumentApi {
  Core = 'viacore',
  Integrate = 'viaintegrate',
  IAM = 'viaiam',
  DocGen = 'viadocgen',
}

export type PresignedUrlRequest = {
  fileName: string;
  fileExt: string;
  fileSize: number;
  contentType: string;
  isUpload?: boolean;
};

export type PresignedUrlResponse = {
  id: number;
  presignedUrl: string;
};

export type DocumentRequest = {
  'x-ss-meta-file-name': string;
  // eslint-disable-next-line spellcheck/spell-checker
  'x-ss-meta-uniqueid': string;
  ContentType: string;
  'Cache-Control': string;
};

export type DocumentMetadata = {
  fileName: string;
  fileExt: string;
  fileSize: number;
  fileType: string;
  documentType?: string;
};

export type DocumentParams = {
  [key: string]: any;
};

export type Document = {
  id: number;
  key: string;
  metadata: DocumentMetadata;
  uploadedDateTime: string;
};

export type TemporaryDocument = {
  htmlContent: string;
  file: File;
};
